/**
 * Created by an.han on 16/10/15.
 */

import $http from '../util/http';
import router from '../routes/index';

// 生成 mutations 方法
function generate(name) {
  return function (state, value) {
    state[name] = value;
  }
}

let promiseObj = {
    'net': true,
    'manager': true,
    'fund': true,
    'company': true,
};

var options = {

  // 多页面共享数据
  state: {
      msg: '',
      message: '',
      activeRouter:"home",
      msgNum: 0,
      isLogin: false,
      userData: null
  },

  // 操作
  actions: {
  },

  // 数据变更
  mutations: {
      getActive(state, router){
          let href = router.path;
          if(href.indexOf('company') > -1){
              state.activeRouter = 'company';
          } else if(href.indexOf('fund') > -1){
              state.activeRouter = 'fund';
          } else  if(href.indexOf('net') > -1){
              state.activeRouter = 'net';
          } else if(href.indexOf('manager') > -1){
              state.activeRouter = 'manager';
          } else if(href === '/'){
              state.activeRouter = 'home';
          } else {
              state.activeRouter = '';
          }
      },
      setActive(state, value){
          state.activeRouter = value;
      },
      setMsgNum(state,value ){
          state.msgNum  = value;
      },
      setLogin(state, flag){
          state.isLogin = flag;
      },
      setLoginData(state, data){
          state.userData = data;
      },
      changeProImg(state, data){
          if(state.userData != null && data) {
              state.userData.promiseFileInfoVo.url = data;
              state.userData.promiseFileInfoVo.auditStatus = 0;
          }
      },
      setPhone(state, data){
        if(state.userData != null && data) {
            state.userData.phone = data;
        }
      },
      //获取用户信息
      getLoginInfo(state, callback){
          if(state.userData == null ){
              $http.request({
                  url: `/account/loginInfo`
              }, (res) => {
                  // console.log(res);
                  if(res.data.code == 200){
                      state.isLogin = true;
                      let dataObj = res.data.data;
                      state.userData = {  ...dataObj };
                      let userData = dataObj;
                      // if( userData == null ||  userData.promiseFileInfoVo == null ||  userData.promiseFileInfoVo.url == null || userData.promiseFileInfoVo.auditStatus == null ||  userData.promiseFileInfoVo.auditStatus== -1||  userData.promiseFileInfoVo.auditStatus== 0){
                      if( userData == null){
                          // router.push("/promise");
                          return false;
                      } else if(typeof callback == 'function'){
                          callback();
                      }
                  }
              }, (err) => {

              });
          } else {
              state.isLogin = true;
              let userData = state.userData;
              // if( userData == null ||  userData.promiseFileInfoVo == null ||  userData.promiseFileInfoVo.url == null || userData.promiseFileInfoVo.auditStatus == null ||  userData.promiseFileInfoVo.auditStatus== -1||  userData.promiseFileInfoVo.auditStatus== 0){
              if( userData == null){
                  // router.push("/promise");
              }else if(typeof callback == 'function'){
                  callback();
              }
          }

      },
      getLoginData(state, callback){
          if(state.userData == null ){
              $http.request({
                  url: `/account/loginInfo`
              }, (res) => {
                  // console.log(res);
                  if(res.data.code == 200){
                      state.isLogin = true;
                      let dataObj = res.data.data;
                      state.userData = {  ...dataObj };
                      if(typeof callback ==='function'){
                          callback();
                      }
                  }
              }, (err) => {

              });
          } else {
              state.isLogin = true;
              // let userData = state.userData;
          }
      },
      //是否要跳转到promise
      isGoPromise(state){
          // let userData = state.userData;
          // console.log(userData);
          // if( userData == null ||  userData.promiseFileInfoVo == null ||  userData.promiseFileInfoVo.url == null || userData.promiseFileInfoVo.auditStatus == null ||  userData.promiseFileInfoVo.auditStatus== -1||  userData.promiseFileInfoVo.auditStatus== 0){
              // router.push("/promise");
          // }
      }
  },
};

//为每个 state 字段生成对应的 mutations 方法
Object.keys(options.state).forEach((key) => {
  options.mutations[key] = generate(key);
});

export default options;


// WEBPACK FOOTER //
// ./src/vuex/store.js